<script>
import { periodicTasksClockedScheduleMethods, } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'


export default {
  name: 'ClockedScheduleDelete',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: true,
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: false,
      submitting: false,
      form: {
        url: null,
        clocked_time: null,
      },
    }
  },
  computed: {},

  methods: {
    ...periodicTasksClockedScheduleMethods,

    deleteObject() {
      let context = this
      context.submitting = true
      const promise = context.deletePeriodicTasksClockedSchedule(context.instanceJson.url)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `Programación eliminada correctamente`
          )
          setTimeout(() => {
            context.submitting = false
            context.oncomplete()
          }, 3000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },

}
</script>

<template>
  <b-modal
    id="delete-modal"
    v-model="modalShow"
    title="Eliminar programación"
    ok-title="Delete"
    ok-variant="danger"
    @hidden="oncancel"
    @ok.prevent="deleteObject"
    >
      <b-container class="p-0">
        <b-row v-if="loading">
          <b-col md="12">
            <div class="text-center">
              <b-spinner
                label="Spinning"
                style="color: #195db2; width: 4rem; height: 4rem"
              ></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <p class="text-center">
              ¿Está seguro de eliminar esta programación?
            </p>
          </b-col>
        </b-row>
      </b-container>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button 
          size="sm"
          variant="secondary"
          :disabled="submitting"
          @click="cancel">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="submitting"
          @click="ok">
          <span
            v-if="!submitting"
            >
            {{ $t('delete') }}
          </span>
          <b-spinner
            v-if="submitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>

  </b-modal>
</template>
<style lang="scss">
</style>